export default "__VITE_ASSET__BwX91fQi__"